import { jsx as l } from "react/jsx-runtime";
import "react";
var o = (c) => /* @__PURE__ */ l("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...c,
  children: /* @__PURE__ */ l("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m22.286 4.239 7.143 2.691C30.857 7.355 32 8.913 32 10.471v14.872c0 1.7-1 3.116-2.571 3.683l-7.143 2.69c-.429.142-1 .284-1.429.284-.857 0-1.571-.283-2.286-.708-.19-.095-.38-.315-.571-.535-.095-.11-.19-.22-.286-.315h-5.428c-2.286 0-4-1.841-4-3.966V25.06c0-.567.428-.992 1.143-.992.714 0 1.142.567 1.142 1.133v1.417c0 .85.715 1.7 1.715 1.7H17V7.78h-4.714c-.857 0-1.715.708-1.715 1.7v1.416c0 .566-.428 1.133-1.142 1.133-.715 0-1.143-.566-1.143-1.133V9.48c0-2.125 1.857-3.966 4-3.966h5.428c.286-.284.572-.567 1-.85 1-.708 2.286-.85 3.572-.425ZM10.143 21.66a1.105 1.105 0 0 1 0-1.558l1-.708h-6C4.429 19.394 4 18.97 4 18.261s.571-1.133 1.143-1.133H11l-1-.991a1.105 1.105 0 0 1 0-1.558 1.128 1.128 0 0 1 1.571 0l2.858 2.832c.142 0 .285.142.285.284.143.141.143.283.143.425 0 .07-.036.141-.071.212a.496.496 0 0 0-.072.212c-.088 0-.122.055-.168.13-.03.046-.063.1-.117.154L11.57 21.66a1.096 1.096 0 0 1-.714.284c-.286 0-.571-.142-.714-.284Z",
    clipRule: "evenodd"
  })
});
export {
  o as default
};
